import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/images/uploads/pdf.png'


const _hoisted_1 = { class: "card card-container" }
const _hoisted_2 = { class: "flex flex-direction-row justify-space-between" }
const _hoisted_3 = { class: "flex-grow-0 flex-shrink-1" }
const _hoisted_4 = {
  key: 2,
  class: "form-group"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = { key: 8 }
const _hoisted_14 = {
  key: 3,
  class: "form-group"
}
const _hoisted_15 = {
  key: 4,
  class: "form-group"
}
const _hoisted_16 = { for: "typeProject" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 5,
  class: "form-group"
}
const _hoisted_19 = {
  key: 6,
  class: "form-group"
}
const _hoisted_20 = {
  key: 7,
  class: "form-group"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 8,
  class: "form-group"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 9,
  class: "form-group"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 10,
  class: "form-group"
}
const _hoisted_28 = {
  key: 11,
  class: "form-group"
}
const _hoisted_29 = {
  key: 12,
  class: "form-group"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 0,
  src: _imports_0,
  class: "doc-image"
}
const _hoisted_32 = {
  key: 13,
  class: "form-group"
}
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { for: "date" }
const _hoisted_35 = {
  key: 0,
  class: "font-color-yellow"
}
const _hoisted_36 = {
  class: "flex flex-direction-column lg:flex-row",
  style: {"column-gap":"4px"}
}
const _hoisted_37 = {
  class: "flex-grow-1",
  style: {"flex-basis":"0"}
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["value"]
const _hoisted_40 = ["value"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "list-item-remove" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  class: "flex-grow-1",
  style: {"flex-basis":"0"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  class: "font-italic",
  style: {"font-size":"small"}
}
const _hoisted_48 = {
  role: "button",
  class: "hint"
}
const _hoisted_49 = {
  class: "speech_bubble tool_tip_text",
  id: "tooltip",
  style: {"display":"inline"}
}
const _hoisted_50 = {
  type: "button",
  class: "close-btn-tooltip mr-4"
}
const _hoisted_51 = {
  key: 14,
  class: "form-group"
}
const _hoisted_52 = {
  key: 0,
  for: "duration"
}
const _hoisted_53 = {
  key: 1,
  for: "duration"
}
const _hoisted_54 = {
  key: 15,
  class: "form-group"
}
const _hoisted_55 = {
  key: 16,
  class: "form-group"
}
const _hoisted_56 = {
  key: 0,
  for: "noOfFreq"
}
const _hoisted_57 = {
  key: 1,
  for: "noOfFreq"
}
const _hoisted_58 = {
  key: 17,
  class: "form-group"
}
const _hoisted_59 = {
  key: 18,
  class: "form-group"
}
const _hoisted_60 = {
  key: 19,
  class: "form-group"
}
const _hoisted_61 = {
  key: 20,
  class: "form-group"
}
const _hoisted_62 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "list-item-remove" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 21,
  class: "form-group"
}
const _hoisted_67 = {
  key: 22,
  class: "form-group"
}
const _hoisted_68 = { for: "visualRep" }
const _hoisted_69 = { title: "Kindly give a description of any demonstration or visual representation you want the practitioner to provide to students in the delivery of this course-support" }
const _hoisted_70 = {
  key: 23,
  class: "form-group"
}
const _hoisted_71 = {
  key: 24,
  class: "form-group"
}
const _hoisted_72 = {
  key: 25,
  class: "form-group"
}
const _hoisted_73 = {
  key: 26,
  class: "form-group"
}
const _hoisted_74 = {
  key: 27,
  class: "form-group"
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = {
  key: 28,
  class: "form-group"
}
const _hoisted_77 = { key: 0 }
const _hoisted_78 = {
  key: 29,
  class: "form-group"
}
const _hoisted_79 = {
  key: 30,
  class: "form-group"
}
const _hoisted_80 = { key: 0 }
const _hoisted_81 = ["readonly"]
const _hoisted_82 = {
  key: 31,
  class: "form-group"
}
const _hoisted_83 = {
  key: 32,
  class: "form-group"
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = ["readonly"]
const _hoisted_86 = {
  key: 33,
  class: "form-group"
}
const _hoisted_87 = { key: 34 }
const _hoisted_88 = { class: "form-group flex flex-direction-row align-content-between" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = {
  key: 0,
  class: "form-group"
}
const _hoisted_93 = { class: "form-group text-align-center" }
const _hoisted_94 = { class: "form-group flex flex-direction-row align-content-between" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { class: "spinner-border spinner-border-sm" }

import { ref, watch } from "vue";
import { Field, ErrorMessage, useForm } from "vee-validate";
import * as yup from "yup";
import InstructorService from "@/services/instructor.service.js";
import Multiselect from "@vueform/multiselect";
import PopupModal from "../user/PopupModal.vue";
import {
  displayLabels,
  physicalDisOptions,
  insDeliveryTypeOptions,
  areaOfExpertiseOptions,
  yearsOfExpOptions,
  deptOptions,
  academicLevelOptions,
  showVisualRep,
  showToast,
  showPriorKnowledge,
  insDeliveryTypeSiteVisitOptions,
  isCapstoneTermProject,
  typeOfProjectOptions,
  typeOfFirmOptions,
  sizeOfFirmOptions,
  ethnicityOptions,
  showLocation,
  showClassroomItems,
  showErrorToast,
  getTimezoneName,
  showAssignmentConnected,
  websiteURL,
} from "@/utils";
import { onBeforeRouteLeave, useRouter } from "vue-router";
import { useConfigStore } from "@/stores/ConfigStore";
import { useModal } from "vuestic-ui";

import { useRecommendationsStore } from "@/stores/RecommendationsStore";
import { useCourseStore } from "@/stores/CourseStore";

const MED_TEXT_MAX_LENGTH = 100;
const MAX_TEXT_MAX_LENGTH = 2000;

const DUR_TEXT_MAX_LENGTH = 10;
const TOP_TEXT_MAX_LENGTH = 250;
const LER_TEXT_MAX_LENGTH = 300;
const LOT_TEXT_MAX_LENGTH = 500;
const DET_TEXT_MAX_LENGTH = 1000;

// Define `disabledFields` to track which fields to disable

export default /*@__PURE__*/_defineComponent({
  __name: 'CourseRequestForm',
  props: {
    id: {},
    formValues: {},
    action: {}
  },
  setup(__props: any) {

const RecommendationsStore = useRecommendationsStore();
const CourseStore = useCourseStore();

const disabledFields = ref(false);

const ConfigStore = useConfigStore();
const router = useRouter();
const { confirm } = useModal();

const courseRequestFields = ConfigStore.config.filter(
  (el) => el.table === "course_request"
);

// eslint-disable-next-line no-undef
const props = __props;

const yearsOfExpOptionsAdded = ["No preference", ...yearsOfExpOptions];
const typeOfFirmOptionsAdded = [
  { label: "No preference", value: "No preference" },
  ...typeOfFirmOptions,
];
const sizeOfFirmOptionsAdded = [
  { label: "No preference", value: "No preference" },
  ...sizeOfFirmOptions,
];
const areaOfExpertiseOptionsAdded = [
  "No preference",
  ...areaOfExpertiseOptions,
];
const ethnicityOptionsAdded = ["No preference", ...ethnicityOptions];

function processFieldWithOthers(fieldData, options) {
  let parsedField = [];
  try {
    parsedField = JSON.parse(fieldData || "[]");
  } catch (e) {
    console.error("Error parsing fieldData:", fieldData, e);
    parsedField = [];
  }

  const predefined = [];
  const customInputs = [];

  const normalizedOptionValues = new Set(
    options.map((opt) =>
      (typeof opt === "object" ? opt.value : opt).toLowerCase()
    )
  );

  parsedField.forEach((value) => {
    const normalizedValue = value.toLowerCase();
    if (normalizedOptionValues.has(normalizedValue)) {
      predefined.push(value);
    } else {
      customInputs.push(value);
    }
  });

  // Add all unknown items as custom inputs, and mark "Others"
  if (customInputs.length > 0 && !predefined.includes("Others")) {
    predefined.push("Others");
  }

  return {
    field: predefined, // Includes known options + "Others"
    text: customInputs.join(", "), // Stores unknown items in text input
  };
}

const formatFn = (dateString) => {
  if (!dateString) return ""; // Return an empty string for invalid dates
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; // Ensure it's a valid date
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is 0-indexed
  const day = date.getDate();
  return `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
};

const onInputWithNotification = (maxLength, event) => {
  const value = event.target.value;
  if (value.length >= maxLength) {
    event.target.value = value.substring(0, maxLength); // Prevent further input
    showErrorToast(`Maximum character limit of ${maxLength} reached.`);
  }
};

const parseFn = (text) => {
  if (!text) return null; // Return null for empty values
  const [year, month, day] = text.split("-");
  const parsedDate = new Date(year, month - 1, day);
  return isNaN(parsedDate.getTime()) ? null : parsedDate; // Validate parsed date
};

const validateDate = (field, meta) => {
  const value = field.value;

  // Ensure the date is valid and not in the past
  const parsedDate = new Date(value);
  if (isNaN(parsedDate.getTime()) || parsedDate < new Date()) {
    meta.valid = false;
    meta.errorMessage = "Invalid or past date provided.";
  } else {
    meta.valid = true;
    meta.errorMessage = "";
  }
};

const schema = yup.object().shape({
  fields: yup.array().default(courseRequestFields),
  academicLevel: yup
    .array()
    .of(yup.string())
    .when("fields", {
      is: (val) => !val.find((el) => el.name === "academicLevel")?.disabled,
      then: (schema) =>
        schema
          .required("Students' academic level is required!")
          .min(1, "Students' academic level is required!"),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  areaOfExpertise: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "areaOfExpertise")?.disabled,
    then: (schema) =>
      schema.required("Area of Expertise/Specialization is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  classSize: yup
    .number()
    .label("Class Size")
    .when("fields", {
      is: (val) => !val.find((el) => el.name === "classSize")?.disabled,
      then: (schema) =>
        schema
          .typeError("Class Size must be a number!")
          .positive()
          .integer()
          .required("Class Size is required!"),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  courseRequestType: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "courseRequestType")?.disabled,
    then: (schema) => schema.required("Course-Support Type is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),

  duration: yup
    .number()
    .label("Duration of Course-Support")
    .when("fields", {
      is: (val) => !val.find((el) => el.name === "duration")?.disabled,
      then: (schema) =>
        schema
          .typeError("Duration of Course-Support must be a number!")
          .positive()
          .integer()
          .required("Duration of Course-Support is required!")
          .test(
            "maxDigits",
            `Duration cannot have more than ${DUR_TEXT_MAX_LENGTH} digits!`,
            (value) => value && value.toString().length <= DUR_TEXT_MAX_LENGTH
          ),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  ethnicity: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "ethnicity")?.disabled,
    then: (schema) => schema.required("Ethnicity is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  gender: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "gender")?.disabled,
    then: (schema) => schema.required("Gender Identity is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  insDeliveryType: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "insDeliveryType")?.disabled,
    then: (schema) => schema.required("Instruction Delivery Mode is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  learning: yup
    .array()
    .of(yup.string())
    .when("fields", {
      is: (val) => !val.find((el) => el.name === "learning")?.disabled,
      then: (schema) =>
        schema
          .required("Learning objective/Expected student Outcome is required!")
          .min(1, "Learning Objective/Expected Student Outcome is required!"),
      otherwise: (schema) => schema.optional().nullable().min(0),
    }),
  levelEducation: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "levelEducation")?.disabled,
    then: (schema) => schema.required("Level of Education is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  needForPreVisit: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "levelEducation")?.disabled &&
      courseRequestType == "Site Visit",
    then: (schema) =>
      schema.required("Need for Pre-Visit by the instructor is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  noOfFreq: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "noOfFreq")?.disabled,
    then: (schema) =>
      schema.required("Frequency of Course-Support is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  physicalDis: yup
    .array()
    .of(yup.string())
    .when(["fields", "courseRequestType", "insDeliveryType"], {
      is: (fields, courseRequestType, insDeliveryType) =>
        !fields.find((el) => el.name === "physicalDis")?.disabled &&
        courseRequestType === "Site Visit" &&
        insDeliveryType !== "Virtual site visit",
      then: (schema) =>
        schema
          .required("Physical disabilities of students is required!")
          .min(1, "At least one disability must be selected!"),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  physicalDis_text: yup.string().when("physicalDis", {
    is: (val) => val?.includes("Others"),
    then: (schema) =>
      schema
        .required("Custom input for 'Others' is required!")
        .max(
          MED_TEXT_MAX_LENGTH,
          `Custom input cannot exceed ${MED_TEXT_MAX_LENGTH} characters`
        ),
    otherwise: (schema) => schema.optional().nullable(),
  }),

  siteOffice: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "siteOffice")?.disabled &&
      courseRequestType == "Site Visit",
    then: (schema) =>
      schema.required(
        "Need to visit the office trailer/site office is required!"
      ),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  studentDept: yup
    .array()
    .of(yup.string())
    .when("fields", {
      is: (val) => !val.find((el) => el.name === "studentDept")?.disabled,
      then: (schema) =>
        schema
          .required("Students' department or Program of study is required!")
          .min(1, "Students' department or Program of study is required!"),
      otherwise: (schema) => schema.optional().nullable().min(0),
    }),
  topic: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "topic")?.disabled,
    then: (schema) =>
      schema
        .required("Topic requiring Course-Support is required!")
        .max(
          TOP_TEXT_MAX_LENGTH,
          `Topic requiring Course-Support cannot be greater than ${TOP_TEXT_MAX_LENGTH} characters`
        ),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  visualRep: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "visualRep")?.disabled &&
      showVisualRep(courseRequestType),
    then: (schema) =>
      schema
        .required(
          "Describe Specific demonstrations/ Visual Representation Required is required!"
        )
        .max(
          LOT_TEXT_MAX_LENGTH,
          `Describe Specific demonstrations/ Visual Representation Required cannot be greater than ${LOT_TEXT_MAX_LENGTH} characters`
        ),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  priorKnowledge: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "priorKnowledge")?.disabled &&
      showPriorKnowledge(courseRequestType),
    then: (schema) =>
      schema
        .required(
          "Students' Prior Knowledge About Topic Requiring Course-Support is required!"
        )
        .max(
          LOT_TEXT_MAX_LENGTH,
          `Students' Prior Knowledge About Topic Requiring Course-Support cannot be greater than ${LOT_TEXT_MAX_LENGTH} characters`
        ),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  yearsOfExp: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "yearsOfExp")?.disabled,
    then: (schema) => schema.required("Years of Experience is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  date: yup
    .array()
    .of(
      yup
        .date()
        .min(new Date(), "Date for Course-Support cannot be in the past!")
    )
    .when(["fields", "courseRequestType"], {
      is: (fields, courseRequestType) =>
        !fields.find((el) => el.name === "date")?.disabled &&
        courseRequestType !== "Mentor for Project",
      then: (schema) =>
        schema
          .required("Date for Course-Support is required!")
          .min(1, "Date for Course-Support is required!"),
      otherwise: (schema) => schema.optional().min(0).nullable(),
    }),
  time: yup
    .array()
    .of(yup.string())
    .when(["fields", "courseRequestType"], {
      is: (fields, courseRequestType) =>
        !fields.find((el) => el.name === "time")?.disabled &&
        courseRequestType !== "Mentor for Project",
      then: (schema) =>
        schema
          .required("Time for Course-Support is required!")
          .min(1, "Time for Course-Support is required!"),
      otherwise: (schema) => schema.optional().min(0).nullable(),
    }),
  generalInfo: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "generalInfo")?.disabled,
    then: (schema) =>
      schema
        .required("Detailed Description of Course-Support Needed is required!")
        .max(
          DET_TEXT_MAX_LENGTH,
          `Detailed Description of Course-Support Needed cannot be greater than ${DET_TEXT_MAX_LENGTH} characters`
        ),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  courseCode: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "courseCode")?.disabled,
    then: (schema) => schema.required("Course Code is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  courseTitle: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "courseTitle")?.disabled,
    then: (schema) => schema.required("Course Title is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  typeProject: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "typeProject")?.disabled &&
      isCapstoneTermProject(courseRequestType),
    then: (schema) => schema.required("Type of Project is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  location: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "location")?.disabled &&
      showLocation(courseRequestType),
    then: (schema) =>
      schema.required("Location of Course-Support is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  projectDescr: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "projectDescr")?.disabled &&
      isCapstoneTermProject(courseRequestType),
    then: (schema) =>
      schema
        .required("Description of Project is required!")
        .max(
          LOT_TEXT_MAX_LENGTH,
          `Description of Project cannot be greater than ${LOT_TEXT_MAX_LENGTH} characters`
        ),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  daysOfMeeting: yup.string().when(["fields", "courseRequestType"], {
    is: (fields, courseRequestType) =>
      !fields.find((el) => el.name === "daysOfMeeting")?.disabled &&
      courseRequestType === "Mentor for Project",
    then: (schema) =>
      schema.required("Days of Meeting with Students is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  startDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === "" ? null : value;
    })
    .when(["fields", "courseRequestType"], {
      is: (fields, courseRequestType) =>
        !fields.find((el) => el.name === "startDate")?.disabled &&
        courseRequestType === "Mentor for Project",
      then: (schema) =>
        schema
          .required("Start Date for Course-Support is required!")
          .min(new Date(), "Start Date cannot be in the past."),
      otherwise: (schema) => schema.optional().nullable(),
    }),

  endDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === "" ? null : value;
    })
    .when(["fields", "courseRequestType"], {
      is: (fields, courseRequestType) =>
        !fields.find((el) => el.name === "endDate")?.disabled &&
        courseRequestType === "Mentor for Project",
      then: (schema) =>
        schema
          .required("End Date for Course-Support is required!")
          .min(yup.ref("startDate"), "End Date cannot be before Start Date."),
      otherwise: (schema) => schema.optional().nullable(),
    }),

  classroomItems: yup
    .string()
    .optional()
    .nullable()
    .max(
      LOT_TEXT_MAX_LENGTH,
      `Available items in the classroom cannot be greater than ${LOT_TEXT_MAX_LENGTH} characters`
    ),
  assigmentConnected: yup
    .string()
    .optional()
    .nullable()
    .max(
      LOT_TEXT_MAX_LENGTH,
      `Is there any Student Assignment Connected to this Course-Support cannot be greater than ${LOT_TEXT_MAX_LENGTH} characters`
    ),
  additionalInformation: yup.string().optional().nullable(),
  typeFirm: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "typeFirm")?.disabled,
    then: (schema) => schema.required("Type of Firm is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  sizeFirm: yup.string().when("fields", {
    is: (val) => !val.find((el) => el.name === "sizeFirm")?.disabled,
    then: (schema) => schema.required("Size of Firm is required!"),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  semester: yup.string(),
  year: yup.string(),
});

const initializePhysicalDisabilities = () => {
  const predefinedOptions = new Set(
    physicalDisOptions.map((opt) => (typeof opt === "object" ? opt.value : opt))
  );

  const parsedField = values.physicalDis || [];
  const predefined = [];
  const customInputs = [];

  parsedField.forEach((value) => {
    if (predefinedOptions.has(value)) {
      predefined.push(value);
    } else {
      customInputs.push(value);
    }
  });

  // Add "Others" if custom inputs exist
  if (customInputs.length > 0 && !predefined.includes("Others")) {
    predefined.push("Others");
  }

  // Update values
  setFieldValue("physicalDis", predefined);
  setFieldValue("physicalDis_text", customInputs.join(", "));
};

const { handleSubmit, errors, values, meta, resetForm, setFieldValue } =
  useForm({
    validationSchema: schema,
  });

resetForm({
  values: {
    ...props.formValues,
    physicalDis: props.formValues.physicalDis || [],
    startDate: props.formValues.startDate
      ? formatFn(props.formValues.startDate)
      : "",
    endDate: props.formValues.endDate ? formatFn(props.formValues.endDate) : "",
  },
});

// Ensure the function is defined before calling it
initializePhysicalDisabilities();

onBeforeRouteLeave(async (to, from) => {
  if (meta.value.dirty && !loading.value && !successful.value) {
    const answer = await confirm({
      message:
        "Your changes on this page have not been saved. Kindly save your changes before leaving the page. Do you want to proceed without saving your changes?",
      okText: "Yes",
      cancelText: "No",
    });
    if (!answer) return false;
  }
});

let loading = ref(false);
let successful = ref(false);
let message = ref("");
let isVisible = ref(false);
let isRecommendationsVisible = ref(false);
let showRecommendationsModal = ref(false);
let date_text = ref("");
let time_text = ref("");
let learning_text = ref("");
let elementVisible = ref(false);
let tooltipTimeout;

const today = new Date(new Date().setDate(new Date().getDate() + 1))
  .toISOString()
  .substring(0, 10);

const showTooltip = () => {
  elementVisible.value = true;
  tooltipTimeout = setTimeout(() => (elementVisible.value = false), 5000);
};
const hideTooltip = () => {
  elementVisible.value = false;
  clearTimeout(tooltipTimeout);
};
const showPopup = () => {
  isVisible.value = true;
};
const hidePopup = () => {
  isVisible.value = false;
};

const uploadFile = (e) => {
  const files = e.target.files || e.dataTransfer.files;
  if (!files.length) return;
  setFieldValue("files", files);
};

const saveTempCourseRequest = () => {
  loading.value = true;

  // Ensure values.physicalDis_text is properly processed
  if (values.physicalDis.includes("Others")) {
    // Ensure custom inputs are split and trimmed
    const customInputs = values.physicalDis_text
      ? values.physicalDis_text.split(",").map((item) => item.trim())
      : [];

    // Retain "Others" while appending custom inputs
    const updatedPhysicalDis = [
      ...values.physicalDis, // Retain all existing options including "Others"
      ...customInputs, // Add custom inputs
    ];

    // Remove duplicate entries (in case custom inputs overlap with existing ones)
    const uniquePhysicalDis = [...new Set(updatedPhysicalDis)];

    // Reassign the new array to values.physicalDis
    setFieldValue("physicalDis", uniquePhysicalDis); // Use setFieldValue to update reactive state
  }

  if (values.courseRequestType === "Others") {
    setFieldValue("courseRequestType", values["courseRequestType-text"]);
  }
  if (values?.studentDept?.includes("Others")) {
    const newStudentDept = [...values.studentDept];
    newStudentDept[newStudentDept.indexOf("Others")] =
      values["studentDept_text"];
    setFieldValue("studentDept", newStudentDept);
  }
  if (values.gender === "Others") {
    setFieldValue("gender", values["gender-text"]);
  }
  if (values.ethnicity === "Others") {
    setFieldValue("ethnicity", values["ethnicity-text"]);
  }
  if (values.areaOfExpertise === "Others") {
    setFieldValue("areaOfExpertise", values["areaOfExpertise-text"]);
  }
  if (values.typeFirm === "Others") {
    setFieldValue("typeFirm", values["typeFirm_text"]);
  }

  // Handle date and time for "Mentor for Project"
  if (values.courseRequestType === "Mentor for Project") {
    const formattedStartDate = formatFn(values["startDate"]);
    const formattedEndDate = formatFn(values["endDate"]);

    setFieldValue("date", [formattedStartDate]);
    setFieldValue("time", [values["time_text"]]);
    setFieldValue("endDate", formattedEndDate);
  }

  InstructorService.saveTempCourseRequest(values).then(
    (response) => {
      loading.value = false;
      successful.value = true;
      showToast("Your course-support request has been saved.");
      router.push({ name: "instructor-feed" });
    },
    (error) => {
      loading.value = false;
      message.value =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
    }
  );
};

const saveCourseRequest = handleSubmit(
  (data) => {
    console.log("validated while submitting");
    loading.value = true;

    // Process "physicalDis" field to include items from "physicalDis_text"
    // Make sure data.physicalDis is an array before calling .includes()
    if (Array.isArray(data.physicalDis) && data.physicalDis.includes("Others")) {
      const customInputs = data.physicalDis_text
        ? data.physicalDis_text.split(",").map((item) => item.trim())
        : [];
      const updatedPhysicalDis = [
        ...data.physicalDis, // Include all existing items, including "Others"
        ...customInputs,     // Add custom inputs
      ];
      // Remove duplicates
      data.physicalDis = [...new Set(updatedPhysicalDis)];
    }

    // For fields that are strings, ensure they exist and are strings before comparing
    if (typeof data.courseRequestType === "string" && data.courseRequestType === "Others") {
      data.courseRequestType = data["courseRequestType-text"];
    }

    // studentDept should be an array of strings
    if (Array.isArray(data.studentDept) && data.studentDept.includes("Others")) {
      const newStudentDept = [...data.studentDept];
      const idx = newStudentDept.indexOf("Others");
      if (idx !== -1) {
        newStudentDept[idx] = data["studentDept_text"];
      }
      data.studentDept = newStudentDept;
    }

    if (typeof data.gender === "string" && data.gender === "Others") {
      data.gender = data["gender-text"];
    }
    if (typeof data.ethnicity === "string" && data.ethnicity === "Others") {
      data.ethnicity = data["ethnicity-text"];
    }
    if (typeof data.areaOfExpertise === "string" && data.areaOfExpertise === "Others") {
      data.areaOfExpertise = data["areaOfExpertise-text"];
    }
    if (typeof data.typeFirm === "string" && data.typeFirm === "Others") {
      data.typeFirm = data["typeFirm_text"];
    }

    // Handle date and time for "Mentor for Project"
    if (data.courseRequestType === "Mentor for Project") {
      const formattedStartDate = formatFn(data["startDate"]);
      const formattedEndDate = formatFn(data["endDate"]);
      data.date = [formattedStartDate];
      data.time = [data["time_text"]];
      data["endDate"] = formattedEndDate;
    }

    InstructorService.saveCourseRequest(data, props.action).then(
      (response) => {
        loading.value = false;
        successful.value = true;
        CourseStore.addCourse(response.data.course);
        router.push({ name: "view-recommendations" });
      },
      (error) => {
        loading.value = false;
        message.value =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
  (error) => {
    console.log("error while submitting");
    isRecommendationsVisible.value = false;
    Object.values(error.errors).forEach((error) => showErrorToast(error));
  }
);

const recommendationsModalAccept = () => {
  showRecommendationsModal.value = false;
  router.push({ name: "instructor-feed" });
};

const removeTime = (val) => {
  const index = values.date.indexOf(val);
  if (index !== -1) {
    const newDateArray = [...values.date];
    const newTimeArray = [...values.time];

    newDateArray.splice(index, 1);
    newTimeArray.splice(index, 1);

    setFieldValue("date", newDateArray);
    setFieldValue("time", newTimeArray);
  }
};

const addTime = () => {
  // Check if the user has already added 5 entries
  if (values.date && values.date.length >= 5) {
    showErrorToast("You can add a maximum of 5 date-time entries.");
    return;
  }

  if (date_text.value && time_text.value) {
    // Check if the date-time pair already exists
    const exists = values.date.some((date, index) => {
      return date === date_text.value && values.time[index] === time_text.value;
    });

    if (!exists) {
      const newDateArray = values.date ? [...values.date] : [];
      const newTimeArray = values.time ? [...values.time] : [];

      newDateArray.push(date_text.value);
      newTimeArray.push(time_text.value);

      setFieldValue("date", newDateArray);
      setFieldValue("time", newTimeArray);

      date_text.value = "";
      time_text.value = "";
    } else {
      showErrorToast("This date and time pair has already been added.");
    }
  } else {
    showErrorToast("Please enter both date and time.");
  }
};

const addLearningObjectives = () => {
  if (!learning_text.value || learning_text.value.trim().length === 0) {
    showErrorToast("Learning objective cannot be empty.");
    return;
  }

  // Check if the character limit is exceeded
  if (learning_text.value.length > LER_TEXT_MAX_LENGTH) {
    learning_text.value = learning_text.value.substring(0, LER_TEXT_MAX_LENGTH);
    showErrorToast(
      `Learning objective cannot exceed ${LER_TEXT_MAX_LENGTH} characters.`
    );
    return;
  }

  // Check if the maximum number of objectives is reached
  if (values.learning && values.learning.length >= 5) {
    showErrorToast("You can add a maximum of 5 learning objectives.");
    return;
  }

  // Add the learning objective if it's not a duplicate
  if (!values.learning?.includes(learning_text.value)) {
    const newLearningArray = values.learning
      ? [...values.learning, learning_text.value]
      : [learning_text.value];
    setFieldValue("learning", newLearningArray);
  }
  learning_text.value = ""; // Clear the input field after adding
};

const removeLearningObjectives = (val) => {
  const newLearningArray = values.learning.filter((item) => item !== val);
  setFieldValue("learning", newLearningArray);
};

let isProgrammaticChange = false; // Flag to avoid recursive updates

watch(
  () => values.physicalDis,
  (newVal) => {
    if (!newVal) {
      disabledFields.value = false; // Reset or set default behavior
      return;
    }

    if (isProgrammaticChange) {
      isProgrammaticChange = false; // Reset flag after programmatic change
      return;
    }

    if (newVal.includes("None")) {
      // If "None" is selected, disable other fields and update physicalDis
      disabledFields.value = true;

      // Avoid infinite recursion by setting the flag
      isProgrammaticChange = true;
      setFieldValue("physicalDis", ["None"]); // Reset to only "None"
    } else {
      // If "None" is removed, enable other fields
      disabledFields.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[57] || (_cache[57] = _createElementVNode("span", { class: "font-color-red" }, "* required field", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(values).semester) + " " + _toDisplayString(_unref(values).year), 1)
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_unref(saveCourseRequest) && _unref(saveCourseRequest)(...args))),
        onKeydown: _cache[56] || (_cache[56] = _withKeys(($event: any) => ($event.preventDefault()), ["enter"])),
        enctype: "multipart/form-data"
      }, [
        _cache[129] || (_cache[129] = _createElementVNode("div", { class: "align-center bold-text flex flex-direction-column" }, [
          _createTextVNode(" General Information "),
          _createElementVNode("span", { style: {"font-style":"italic","font-size":"small"} }, "This information will be shared with industry practitioner")
        ], -1)),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'semester')?.disabled
          )
          ? (_openBlock(), _createBlock(_unref(Field), {
              key: 0,
              name: "semester",
              hidden: ""
            }))
          : _createCommentVNode("", true),
        (!_unref(courseRequestFields).find((el) => el.name === 'year')?.disabled)
          ? (_openBlock(), _createBlock(_unref(Field), {
              key: 1,
              name: "year",
              hidden: ""
            }))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'courseRequestType')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[66] || (_cache[66] = _createElementVNode("label", { for: "courseRequestType" }, [
                _createTextVNode("Course-Support Type"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).courseRequestType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(values).courseRequestType) = $event)),
                name: "courseRequestType",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).courseRequestType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(values).courseRequestType) = $event)),
                    options: [
                { label: 'Seminar', value: 'Seminar' },
                { label: 'Site Visit', value: 'Site Visit' },
                { label: 'Workshop', value: 'Workshop' },
                { label: 'Guest Lecture', value: 'Guest Lecture' },
                { label: 'Judge for Project', value: 'Judge for Project' },
                { label: 'Mentor for Project', value: 'Mentor for Project' },
                {
                  label: 'Sponsor for Project (Context Provider)',
                  value: 'Sponsor for Project',
                },
                { label: 'Labs', value: 'Labs' },
                { label: 'Others, please specify', value: 'Others' },
              ],
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              (_unref(values).courseRequestType === 'Others')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_unref(Field), {
                      name: "courseRequestType-text",
                      type: "text",
                      placeholder: "Please Specify",
                      class: "form-control bg-others"
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(ErrorMessage), {
                name: "courseRequestType",
                class: "error-feedback"
              }),
              (_unref(values).courseRequestType === 'Site Visit')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[58] || (_cache[58] = [
                    _createElementVNode("b", null, "Site visit", -1),
                    _createTextVNode(" is a means to expose students to the workplace and work practices on construction job sites.")
                  ])))
                : _createCommentVNode("", true),
              (_unref(values).courseRequestType === 'Guest Lecture')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[59] || (_cache[59] = [
                    _createElementVNode("b", null, "Guest lecture", -1),
                    _createTextVNode(" entails bringing practitioners into the classroom to discuss technical topics from their experience.")
                  ])))
                : _createCommentVNode("", true),
              (_unref(values).courseRequestType === 'Seminar')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[60] || (_cache[60] = [
                    _createElementVNode("b", null, "Seminar", -1),
                    _createTextVNode(" is for sharing knowledge, and facilitating discussions on a specific topic or subject. It can also be an avenue to present their ideas and experiences to students.")
                  ])))
                : _createCommentVNode("", true),
              (_unref(values).courseRequestType === 'Workshop')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[61] || (_cache[61] = [
                    _createElementVNode("b", null, "Workshop", -1),
                    _createTextVNode(" is an interactive learning and skill-building session to provide students with hands-on experience and practical training in a specific area or to develop certain skills.")
                  ])))
                : _createCommentVNode("", true),
              (_unref(values).courseRequestType === 'Labs')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _cache[62] || (_cache[62] = [
                    _createElementVNode("b", null, "Laboratory session", -1),
                    _createTextVNode(" is a practical, hands-on learning experience that takes place in a laboratory where students get the opportunity to apply theoretical concepts to real-world construction tasks.")
                  ])))
                : _createCommentVNode("", true),
              (_unref(values).courseRequestType === 'Judge for Project')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _cache[63] || (_cache[63] = [
                    _createElementVNode("b", null, "Judge for project", -1),
                    _createTextVNode(" involves assessing and appraising students’ projects based on established guidelines, client expectations, and project outcomes.")
                  ])))
                : _createCommentVNode("", true),
              (_unref(values).courseRequestType === 'Mentor for Project')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _cache[64] || (_cache[64] = [
                    _createElementVNode("b", null, "Mentor for project", -1),
                    _createTextVNode(": This entails providing professional guidance to students throughout the delivery of their project.")
                  ])))
                : _createCommentVNode("", true),
              (_unref(values).courseRequestType === 'Sponsor for Project')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _cache[65] || (_cache[65] = [
                    _createElementVNode("b", null, "Sponsor for project", -1),
                    _createTextVNode(": This entails providing context for students’ project and acting as client.")
                  ])))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'insDeliveryType')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[67] || (_cache[67] = _createElementVNode("label", { for: "insDeliveryType" }, [
                _createTextVNode("Instruction Delivery Mode"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).insDeliveryType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(values).insDeliveryType) = $event)),
                name: "insDeliveryType",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field, meta }) => [
                  (_unref(values).courseRequestType === 'Site Visit')
                    ? (_openBlock(), _createBlock(_unref(Multiselect), _mergeProps({ key: 0 }, field, {
                        modelValue: _unref(values).insDeliveryType,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).insDeliveryType) = $event)),
                        options: _unref(insDeliveryTypeSiteVisitOptions),
                        searchable: true,
                        mode: "single",
                        disabled: props.action === 'view',
                        class: { 'field-bg-color': !meta.dirty && !meta.valid }
                      }), null, 16, ["modelValue", "options", "disabled", "class"]))
                    : (_openBlock(), _createBlock(_unref(Multiselect), _mergeProps({ key: 1 }, field, {
                        modelValue: _unref(values).insDeliveryType,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(values).insDeliveryType) = $event)),
                        options: _unref(insDeliveryTypeOptions),
                        mode: "single",
                        searchable: true,
                        disabled: props.action === 'view',
                        class: { 'field-bg-color': !meta.dirty && !meta.valid }
                      }), null, 16, ["modelValue", "options", "disabled", "class"]))
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "insDeliveryType",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'typeProject')
              ?.disabled && _unref(isCapstoneTermProject)(_unref(values).courseRequestType)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, [
                _cache[68] || (_cache[68] = _createTextVNode(" Type of Project")),
                (_unref(values).courseRequestType === 'Sponsor for Project')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Required"))
                  : _createCommentVNode("", true),
                _cache[69] || (_cache[69] = _createElementVNode("span", { class: "super font-color-red" }, "*", -1))
              ]),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).typeProject,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(values).typeProject) = $event)),
                name: "typeProject",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).typeProject,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(values).typeProject) = $event)),
                    options: _unref(typeOfProjectOptions),
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view'
                  }), null, 16, ["modelValue", "options", "disabled"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "typeProject",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'projectDescr')
              ?.disabled && _unref(isCapstoneTermProject)(_unref(values).courseRequestType)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _cache[70] || (_cache[70] = _createElementVNode("label", { for: "projectDescr" }, [
                _createTextVNode(" Description of Project"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), { name: "projectDescr" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    placeholder: "Please Specify",
                    maxlength: LOT_TEXT_MAX_LENGTH,
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (onInputWithNotification(LOT_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).projectDescr ? _unref(values).projectDescr.length : 0) + " / " + _toDisplayString(LOT_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              (_unref(meta).dirty && !_unref(meta).valid)
                ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                    key: 0,
                    name: "projectDescr",
                    class: "error-feedback"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'academicLevel')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[71] || (_cache[71] = _createElementVNode("label", { for: "academicLevel" }, [
                _createTextVNode("Students' Academic Level"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).academicLevel,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(values).academicLevel) = $event)),
                name: "academicLevel",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).academicLevel,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(values).academicLevel) = $event)),
                    options: _unref(academicLevelOptions),
                    mode: "tags",
                    multipleLabel: _unref(displayLabels),
                    hideSelected: false,
                    closeOnSelect: false,
                    closeOnDeselect: false,
                    disabled: true,
                    searchable: true
                  }), null, 16, ["modelValue", "options", "multipleLabel"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "academicLevel",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'studentDept')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _cache[72] || (_cache[72] = _createElementVNode("label", { for: "studentDept" }, [
                _createTextVNode(" Students' Department or Program of Study"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).studentDept,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(values).studentDept) = $event)),
                name: "studentDept",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).studentDept,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(values).studentDept) = $event)),
                    options: _unref(deptOptions),
                    mode: "tags",
                    multipleLabel: _unref(displayLabels),
                    hideSelected: false,
                    closeOnSelect: false,
                    closeOnDeselect: false,
                    disabled: true,
                    searchable: true
                  }), null, 16, ["modelValue", "options", "multipleLabel"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              (_unref(values).studentDept && _unref(values).studentDept.includes('Others'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_unref(Field), {
                      name: "studentDept_text",
                      type: "text",
                      placeholder: "Please Specify",
                      class: "form-control bg-others",
                      readonly: props.action === 'view'
                    }, null, 8, ["readonly"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(ErrorMessage), {
                name: "studentDept",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'classSize')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_unref(values).courseRequestType !== 'Mentor for Project')
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _cache[73] || (_cache[73] = [
                    _createElementVNode("label", { for: "classSize" }, [
                      _createTextVNode("Class Size"),
                      _createElementVNode("span", { class: "super font-color-red" }, "*")
                    ], -1)
                  ])))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, _cache[74] || (_cache[74] = [
                    _createElementVNode("label", { for: "classSize" }, [
                      _createTextVNode("Size of student group to mentor"),
                      _createElementVNode("span", { class: "super font-color-red" }, "*")
                    ], -1)
                  ]))),
              _createVNode(_unref(Field), { name: "classSize" }, {
                default: _withCtx(({ field, meta }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: [{
                'field-bg-color': !meta.dirty,
                'field-border-error': meta.dirty && !meta.valid,
              }, "form-control"],
                    type: "text",
                    readonly: "true"
                  }), null, 16),
                  (meta.dirty && !meta.valid)
                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                        key: 0,
                        name: "classSize",
                        class: "error-feedback"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'physicalDis')
              ?.disabled &&
            _unref(values).courseRequestType === 'Site Visit' &&
            _unref(values).insDeliveryType !== 'Virtual site visit'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _cache[75] || (_cache[75] = _createElementVNode("label", { for: "physicalDis" }, [
                _createTextVNode(" Physical Disabilities of Students "),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).physicalDis,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(values).physicalDis) = $event)),
                name: "physicalDis",
                type: "text",
                class: _normalizeClass(["form-control", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).physicalDis,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(values).physicalDis) = $event)),
                    options: _unref(physicalDisOptions),
                    mode: "tags",
                    searchable: true,
                    multipleLabel: _unref(displayLabels),
                    disabled: props.action === 'view',
                    hideSelected: false,
                    closeOnSelect: false,
                    closeOnDeselect: false
                  }), {
                    option: _withCtx(({ option }) => [
                      _createTextVNode(_toDisplayString(option.label), 1)
                    ]),
                    singleLabel: _withCtx(({ option }) => [
                      _createTextVNode(_toDisplayString(option.label), 1)
                    ]),
                    _: 2
                  }, 1040, ["modelValue", "options", "multipleLabel", "disabled"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              (_unref(values).physicalDis && _unref(values).physicalDis.includes('Others'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_unref(Field), {
                      name: "physicalDis_text",
                      type: "text",
                      placeholder: "Please Specify",
                      class: _normalizeClass(["form-control bg-others", {
                'input-error':
                  _unref(values).physicalDis_text &&
                  _unref(values).physicalDis_text.length > MED_TEXT_MAX_LENGTH,
              }]),
                      modelValue: _unref(values).physicalDis_text,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(values).physicalDis_text) = $event)),
                      maxlength: MED_TEXT_MAX_LENGTH,
                      onInput: _cache[15] || (_cache[15] = ($event: any) => (onInputWithNotification(MED_TEXT_MAX_LENGTH, $event)))
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                'text-danger':
                  _unref(values).physicalDis_text &&
                  _unref(values).physicalDis_text.length > MED_TEXT_MAX_LENGTH,
              })
                    }, _toDisplayString(_unref(values).physicalDis_text ? _unref(values).physicalDis_text.length : 0) + " / " + _toDisplayString(MED_TEXT_MAX_LENGTH) + " characters ", 3)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(ErrorMessage), {
                name: "physicalDis",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'courseCode')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _cache[76] || (_cache[76] = _createElementVNode("label", { for: "courseCode" }, [
                _createTextVNode("Course Code"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), { name: "courseCode" }, {
                default: _withCtx(({ field, meta }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    readonly: true
                  }), null, 16),
                  (meta.dirty && !meta.valid)
                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                        key: 0,
                        name: "courseCode",
                        class: "error-feedback"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'courseTitle')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _cache[77] || (_cache[77] = _createElementVNode("label", { for: "courseTitle" }, [
                _createTextVNode("Course Title"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), { name: "courseTitle" }, {
                default: _withCtx(({ field, meta }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    readonly: true
                  }), null, 16),
                  (meta.dirty && !meta.valid)
                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                        key: 0,
                        name: "courseTitle",
                        class: "error-feedback"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'file')?.disabled &&
            _unref(values).courseRequestType === 'Judge for Project'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _cache[78] || (_cache[78] = _createElementVNode("label", { for: "file" }, "RFP (Request for proposal)", -1)),
              _createElementVNode("input", {
                type: "file",
                name: "file",
                onChange: uploadFile,
                accept: "application/pdf",
                class: "form-control"
              }, null, 32),
              _createElementVNode("a", {
                href: _unref(websiteURL) + '/course_support/' + _unref(values).fileName,
                download: "",
                style: {"color":"var(--bs-body-color)"},
                target: "_blank"
              }, [
                (_unref(values).fileName)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_30),
              (_unref(meta).dirty && !_unref(meta).valid)
                ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                    key: 0,
                    name: "file",
                    class: "error-feedback"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find(
              (el) => el.name === 'additionalInformation'
            )?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _cache[79] || (_cache[79] = _createElementVNode("label", { for: "additionalInformation" }, "Link to Additional Course Information", -1)),
              _createVNode(_unref(Field), { name: "additionalInformation" }, {
                default: _withCtx(({ field, meta }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    placeholder: "https://",
                    readonly: true
                  }), null, 16),
                  (meta.dirty && !meta.valid)
                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                        key: 0,
                        name: "additionalInformation",
                        class: "error-feedback"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("label", _hoisted_34, [
            _cache[80] || (_cache[80] = _createTextVNode("When the Course-Support is Needed")),
            _cache[81] || (_cache[81] = _createElementVNode("span", { class: "super font-color-red" }, "*", -1)),
            (_unref(values).courseRequestType !== 'Mentor for Project')
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, " (Multiple Date & Time are allowed) "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              (_unref(values).courseRequestType === 'Mentor for Project')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_unref(Field), { name: "startDate" }, {
                      default: _withCtx(({ field, meta }) => [
                        _createElementVNode("input", _mergeProps(field, {
                          class: ["form-control", {
                      'field-bg-color': !meta.dirty,
                      'field-border-error': meta.dirty && !meta.valid,
                    }],
                          type: "date",
                          placeholder: "Start YYYY-MM-DD",
                          value: field.value,
                          onInput: _cache[16] || (_cache[16] = ($event: any) => (_unref(setFieldValue)('startDate', $event.target.value)))
                        }), null, 16, _hoisted_39)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      name: "startDate",
                      class: "error-feedback"
                    }),
                    _createVNode(_unref(Field), { name: "endDate" }, {
                      default: _withCtx(({ field, meta }) => [
                        _createElementVNode("input", _mergeProps(field, {
                          class: ["form-control", {
                      'field-bg-color': !meta.dirty,
                      'field-border-error': meta.dirty && !meta.valid,
                    }],
                          type: "date",
                          placeholder: "End YYYY-MM-DD",
                          value: field.value,
                          onInput: _cache[17] || (_cache[17] = ($event: any) => (_unref(setFieldValue)('endDate', $event.target.value)))
                        }), null, 16, _hoisted_40)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      name: "endDate",
                      class: "error-feedback"
                    })
                  ]))
                : (
                  !_unref(courseRequestFields).find((el) => el.name === 'date')
                    ?.disabled
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createVNode(_unref(Field), {
                        name: "date_text",
                        type: "date",
                        class: "form-control",
                        modelValue: _unref(date_text),
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(date_text) ? (date_text).value = $event : date_text = $event)),
                        min: _unref(today)
                      }, null, 8, ["modelValue", "min"]),
                      _createVNode(_unref(ErrorMessage), {
                        name: "date_text",
                        class: "error-feedback"
                      }),
                      (_unref(values).date != null)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"display":"flex","flex-wrap":"wrap"},
                            class: _normalizeClass({ 'pointer-events-none': props.action === 'view' })
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(values).date, (item, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: item,
                                class: "list-item"
                              }, [
                                _createTextVNode(_toDisplayString(item + " at " + _unref(values).time[index]) + " ", 1),
                                _createElementVNode("span", _hoisted_42, [
                                  _createElementVNode("span", {
                                    class: "list-item-remove-icon",
                                    onClick: ($event: any) => (removeTime(item))
                                  }, null, 8, _hoisted_43)
                                ])
                              ]))
                            }), 128))
                          ], 2))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_44, [
              (
                  !_unref(courseRequestFields).find((el) => el.name === 'time')
                    ?.disabled &&
                  _unref(values).courseRequestType === 'Mentor for Project'
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createVNode(_unref(Field), { name: "time_text" }, {
                      default: _withCtx(({ field }) => [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "time",
                          class: "form-control"
                        }), null, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      name: "time",
                      class: "error-feedback"
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      name: "time",
                      class: "error-feedback"
                    })
                  ]))
                : (
                  !_unref(courseRequestFields).find((el) => el.name === 'time')
                    ?.disabled
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createVNode(_unref(Field), {
                        name: "time_text",
                        type: "time",
                        class: "form-control",
                        modelValue: _unref(time_text),
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(time_text) ? (time_text).value = $event : time_text = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(ErrorMessage), {
                        name: "time_text",
                        class: "error-feedback"
                      })
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_47, [
                _createTextVNode(_toDisplayString(_unref(getTimezoneName)()) + " ", 1),
                _createElementVNode("span", _hoisted_48, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-circle-question",
                    onClick: showTooltip
                  }),
                  _withDirectives(_createElementVNode("span", _hoisted_49, [
                    _createElementVNode("button", _hoisted_50, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-xmark",
                        class: "close-btn-icon",
                        onClick: hideTooltip
                      })
                    ]),
                    _cache[82] || (_cache[82] = _createElementVNode("p", { style: {"margin-bottom":"0px"} }, " This is your local timezone. ", -1))
                  ], 512), [
                    [_vShow, _unref(elementVisible)]
                  ])
                ])
              ])
            ]),
            (_unref(values).courseRequestType !== 'Mentor for Project')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ml-2 cursor-pointer d-inline flex-shrink-1 flex-grow-0 btn btn-primary w-6rem",
                  style: {"height":"2.25rem"},
                  onClick: addTime
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin":"auto"},
                    icon: "fa-solid fa-plus",
                    title: "Add"
                  }),
                  _cache[83] || (_cache[83] = _createTextVNode("  ")),
                  _cache[84] || (_cache[84] = _createElementVNode("span", null, "Add", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'duration')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              (_unref(values).courseRequestType === 'Mentor for Project')
                ? (_openBlock(), _createElementBlock("label", _hoisted_52, _cache[85] || (_cache[85] = [
                    _createTextVNode("Duration of Meeting with Students"),
                    _createElementVNode("span", { class: "super font-color-red" }, "*", -1),
                    _createElementVNode("span", { class: "font-color-yellow" }, " (in minutes)", -1)
                  ])))
                : (_openBlock(), _createElementBlock("label", _hoisted_53, _cache[86] || (_cache[86] = [
                    _createTextVNode("Duration of Course-Support"),
                    _createElementVNode("span", { class: "super font-color-red" }, "*", -1),
                    _createElementVNode("span", { class: "font-color-yellow" }, " (in minutes)", -1)
                  ]))),
              _createVNode(_unref(Field), { name: "duration" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    maxlength: DUR_TEXT_MAX_LENGTH,
                    onInput: _cache[20] || (_cache[20] = ($event: any) => (onInputWithNotification(DUR_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).duration ? _unref(values).duration.length : 0) + " / " + _toDisplayString(DUR_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              (_unref(meta).dirty && !_unref(meta).valid)
                ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                    key: 2,
                    name: "duration",
                    class: "error-feedback"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'location')
              ?.disabled && _unref(showLocation)(_unref(values).courseRequestType)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _cache[87] || (_cache[87] = _createElementVNode("label", { for: "location" }, [
                _createTextVNode("Location of Classroom "),
                _createElementVNode("span", { class: "super font-color-red" }, "*"),
                _createElementVNode("span", { class: "font-color-yellow" }, " (Actual Address Including Room Number)")
              ], -1)),
              _createVNode(_unref(Field), { name: "location" }, {
                default: _withCtx(({ field, meta }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    readonly: true
                  }), null, 16),
                  (meta.dirty && !meta.valid)
                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                        key: 0,
                        name: "location",
                        class: "error-feedback"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'noOfFreq')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              (_unref(values).courseRequestType === 'Mentor for Project')
                ? (_openBlock(), _createElementBlock("label", _hoisted_56, _cache[88] || (_cache[88] = [
                    _createTextVNode("Frequency of Meeting with Students"),
                    _createElementVNode("span", { class: "super font-color-red" }, "*", -1)
                  ])))
                : (_openBlock(), _createElementBlock("label", _hoisted_57, _cache[89] || (_cache[89] = [
                    _createTextVNode("Frequency of Course-Support"),
                    _createElementVNode("span", { class: "super font-color-red" }, "*", -1),
                    _createElementVNode("span", { class: "font-color-yellow" }, " (How Often?)", -1)
                  ]))),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).noOfFreq,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(values).noOfFreq) = $event)),
                name: "noOfFreq",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field, meta }) => [
                  (_unref(values).courseRequestType === 'Mentor for Project')
                    ? (_openBlock(), _createBlock(_unref(Multiselect), _mergeProps({ key: 0 }, field, {
                        modelValue: _unref(values).noOfFreq,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(values).noOfFreq) = $event)),
                        options: ['Once a week', 'Once in two weeks', 'Once a month'],
                        mode: "single",
                        searchable: true,
                        disabled: props.action === 'view',
                        class: { 'field-bg-color': !meta.dirty && !meta.valid }
                      }), null, 16, ["modelValue", "disabled", "class"]))
                    : (_openBlock(), _createBlock(_unref(Multiselect), _mergeProps({ key: 1 }, field, {
                        modelValue: _unref(values).noOfFreq,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(values).noOfFreq) = $event)),
                        options: [
                'One-off',
                'Once in a month',
                'Once in two months',
                'Once in three months',
                'Throughout the semester',
              ],
                        mode: "single",
                        searchable: true,
                        disabled: props.action === 'view',
                        class: { 'field-bg-color': !meta.dirty && !meta.valid }
                      }), null, 16, ["modelValue", "disabled", "class"]))
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "noOfFreq",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'daysOfMeeting')
              ?.disabled && _unref(values).courseRequestType === 'Mentor for Project'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _cache[90] || (_cache[90] = _createElementVNode("label", { for: "daysOfMeeting" }, [
                _createTextVNode("Days of Meeting with Students"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).daysOfMeeting,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(values).daysOfMeeting) = $event)),
                name: "daysOfMeeting",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field, meta }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).daysOfMeeting,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(values).daysOfMeeting) = $event)),
                    options: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday',
              ],
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !meta.dirty && !meta.valid }
                  }), null, 16, ["modelValue", "disabled", "class"]),
                  (meta.dirty && !meta.valid)
                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                        key: 0,
                        name: "daysOfMeeting",
                        class: "error-feedback"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "class"])
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'topic')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _cache[91] || (_cache[91] = _createElementVNode("label", { for: "topic" }, [
                _createTextVNode("Topic Requiring Course-Support"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), { name: "topic" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    maxlength: TOP_TEXT_MAX_LENGTH,
                    onInput: _cache[26] || (_cache[26] = ($event: any) => (onInputWithNotification(TOP_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).topic ? _unref(values).topic.length : 0) + " / " + _toDisplayString(TOP_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              (_unref(meta).dirty && !_unref(meta).valid)
                ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                    key: 0,
                    name: "topic",
                    class: "error-feedback"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'priorKnowledge')
              ?.disabled && _unref(showPriorKnowledge)(_unref(values).courseRequestType)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _cache[92] || (_cache[92] = _createElementVNode("label", { for: "priorKnowledge" }, [
                _createTextVNode("Students' Prior Knowledge About Topic Requiring Course-Support "),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), { name: "priorKnowledge" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    maxlength: LOT_TEXT_MAX_LENGTH,
                    onInput: _cache[27] || (_cache[27] = ($event: any) => (onInputWithNotification(LOT_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).priorKnowledge ? _unref(values).priorKnowledge.length : 0) + " / " + _toDisplayString(LOT_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              (_unref(meta).dirty && !_unref(meta).valid)
                ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                    key: 0,
                    name: "priorKnowledge",
                    class: "error-feedback"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'learning')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _cache[95] || (_cache[95] = _createElementVNode("label", { for: "learning" }, [
                _createTextVNode("Learning Objective/Expected Student Outcomes"),
                _createElementVNode("span", { class: "super font-color-red" }, "*"),
                _createElementVNode("span", { class: "font-color-yellow" }, " (You can add multiple)")
              ], -1)),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_unref(Field), {
                  name: "learning_text",
                  modelValue: _unref(learning_text),
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_isRef(learning_text) ? (learning_text).value = $event : learning_text = $event)),
                  readonly: props.action === 'view',
                  onKeyup: _withKeys(_withModifiers(addLearningObjectives, ["prevent"]), ["enter"])
                }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      class: "form-control",
                      type: "text",
                      maxlength: LER_TEXT_MAX_LENGTH,
                      onInput: _cache[28] || (_cache[28] = ($event: any) => (onInputWithNotification(LER_TEXT_MAX_LENGTH, $event)))
                    }), null, 16)
                  ]),
                  _: 1
                }, 8, ["modelValue", "readonly", "onKeyup"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ml-2 cursor-pointer btn btn-primary w-6rem",
                  style: {"display":"inline","justify-content":"center"},
                  onClick: addLearningObjectives,
                  disabled: 
                !_unref(learning_text).trim() ||
                _unref(learning_text).length > LER_TEXT_MAX_LENGTH
              
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin":"auto"},
                    icon: "fa-solid fa-plus",
                    title: "Add Learning Objective/Expected Student Outcomes"
                  }),
                  _cache[93] || (_cache[93] = _createTextVNode("   ")),
                  _cache[94] || (_cache[94] = _createElementVNode("span", null, "Add", -1))
                ], 8, _hoisted_63)
              ]),
              _createTextVNode(" " + _toDisplayString(_unref(learning_text) ? _unref(learning_text).length : 0) + " / " + _toDisplayString(LER_TEXT_MAX_LENGTH) + " characters ", 1),
              _createVNode(_unref(ErrorMessage), {
                name: "learning",
                class: "error-feedback"
              }),
              (_unref(values).learning != null)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: {"display":"flex","flex-wrap":"wrap"},
                    class: _normalizeClass({ 'pointer-events-none': props.action === 'view' })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(values).learning, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: item,
                        class: "list-item"
                      }, [
                        _createTextVNode(_toDisplayString(item) + " ", 1),
                        _createElementVNode("span", _hoisted_64, [
                          _createElementVNode("span", {
                            class: "list-item-remove-icon",
                            onClick: ($event: any) => (removeLearningObjectives(item))
                          }, null, 8, _hoisted_65)
                        ])
                      ]))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'needForPreVisit')
              ?.disabled && _unref(values).courseRequestType === 'Site Visit'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _cache[96] || (_cache[96] = _createElementVNode("label", { for: "needForPreVisit" }, [
                _createTextVNode(" Need for Pre-Visit by the Instructor"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).needForPreVisit,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(values).needForPreVisit) = $event)),
                name: "needForPreVisit",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).needForPreVisit,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(values).needForPreVisit) = $event)),
                    options: ['Yes', 'No'],
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "needForPreVisit",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'visualRep')
              ?.disabled && _unref(showVisualRep)(_unref(values).courseRequestType)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createElementVNode("label", _hoisted_68, [
                _cache[97] || (_cache[97] = _createTextVNode("Describe Specific Demonstrations/Visual Representation Required ")),
                _cache[98] || (_cache[98] = _createElementVNode("span", { class: "super font-color-red" }, "*", -1)),
                _cache[99] || (_cache[99] = _createTextVNode("   ")),
                _createElementVNode("span", _hoisted_69, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle-question" })
                ])
              ]),
              _createVNode(_unref(Field), { name: "visualRep" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    maxlength: LOT_TEXT_MAX_LENGTH,
                    onInput: _cache[32] || (_cache[32] = ($event: any) => (onInputWithNotification(LOT_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).visualRep ? _unref(values).visualRep.length : 0) + " / " + _toDisplayString(LOT_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ErrorMessage), {
                name: "visualRep",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'siteOffice')
              ?.disabled && _unref(values).courseRequestType === 'Site Visit'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
              _cache[100] || (_cache[100] = _createElementVNode("label", { for: "siteOffice" }, [
                _createTextVNode("Need to Visit the Office Trailer/Site Office for any Demonstration "),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).siteOffice,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(values).siteOffice) = $event)),
                name: "siteOffice",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).siteOffice,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(values).siteOffice) = $event)),
                    options: ['Yes', 'No'],
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "siteOffice",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'classroomItems')
              ?.disabled && _unref(showClassroomItems)(_unref(values).courseRequestType)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
              _cache[101] || (_cache[101] = _createElementVNode("label", { for: "classroomItems" }, " Available items in the classroom e.g., projector, HDMI, whiteboard ", -1)),
              _createVNode(_unref(Field), { name: "classroomItems" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    maxlength: LOT_TEXT_MAX_LENGTH,
                    onInput: _cache[35] || (_cache[35] = ($event: any) => (onInputWithNotification(LOT_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).classroomItems ? _unref(values).classroomItems.length : 0) + " / " + _toDisplayString(LOT_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ErrorMessage), {
                name: "classroomItems",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'assigmentConnected')
              ?.disabled && _unref(showAssignmentConnected)(_unref(values).courseRequestType)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _cache[102] || (_cache[102] = _createElementVNode("label", { for: "assigmentConnected" }, " Is there any Student Assignment Connected to this Course-Support? If yes, Please Provide Details. ", -1)),
              _createVNode(_unref(Field), { name: "assigmentConnected" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    maxlength: LOT_TEXT_MAX_LENGTH,
                    onInput: _cache[36] || (_cache[36] = ($event: any) => (onInputWithNotification(LOT_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).assigmentConnected ? _unref(values).assigmentConnected.length : 0) + " / " + _toDisplayString(LOT_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ErrorMessage), {
                name: "assigmentConnected",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'generalInfo')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
              _cache[103] || (_cache[103] = _createElementVNode("label", { for: "generalInfo" }, [
                _createTextVNode("Detailed Description of Course-Support Needed"),
                _createElementVNode("span", { class: "super font-color-red" }, "* "),
                _createElementVNode("span", { class: "font-color-yellow" }, "(Please describe the format of the class and/or the form of engagement you desire from the practitioner)")
              ], -1)),
              _createVNode(_unref(Field), { name: "generalInfo" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    class: "form-control",
                    type: "text",
                    maxlength: DET_TEXT_MAX_LENGTH,
                    onInput: _cache[37] || (_cache[37] = ($event: any) => (onInputWithNotification(DET_TEXT_MAX_LENGTH, $event)))
                  }), null, 16),
                  _createTextVNode(" " + _toDisplayString(_unref(values).generalInfo ? _unref(values).generalInfo.length : 0) + " / " + _toDisplayString(DET_TEXT_MAX_LENGTH) + " characters ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ErrorMessage), {
                name: "generalInfo",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        _cache[130] || (_cache[130] = _createElementVNode("br", null, null, -1)),
        _cache[131] || (_cache[131] = _createElementVNode("div", { class: "align-center bold-text flex flex-direction-column" }, [
          _createTextVNode(" Preference Definition (Industry Practitioner Related) "),
          _createElementVNode("span", { style: {"font-style":"italic","font-size":"small"} }, "This information will not be shared with industry practitioners")
        ], -1)),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'gender')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
              _cache[104] || (_cache[104] = _createElementVNode("label", { for: "gender" }, [
                _createTextVNode("Gender Identity"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).gender,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(values).gender) = $event)),
                name: "gender",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).gender,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(values).gender) = $event)),
                    options: [
                { label: 'No preference', value: 'No preference' },
                { label: 'Male', value: 'Male' },
                { label: 'Female', value: 'Female' },
                { label: 'Others, please specify', value: 'Others' },
              ],
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              (_unref(values).gender === 'Others')
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createVNode(_unref(Field), {
                      name: "gender-text",
                      type: "text",
                      placeholder: "Please Specify",
                      class: "form-control bg-others",
                      readonly: props.action === 'view'
                    }, null, 8, ["readonly"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(ErrorMessage), {
                name: "gender",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'ethnicity')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _cache[105] || (_cache[105] = _createElementVNode("label", { for: "ethnicity" }, [
                _createTextVNode("Ethnicity"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).ethnicity,
                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(values).ethnicity) = $event)),
                name: "ethnicity",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).ethnicity,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(values).ethnicity) = $event)),
                    options: ethnicityOptionsAdded,
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              (_unref(values).ethnicity === 'Others')
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createVNode(_unref(Field), {
                      name: "ethnicity-text",
                      type: "text",
                      placeholder: "Please Specify",
                      class: "form-control bg-others",
                      readonly: props.action === 'view'
                    }, null, 8, ["readonly"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(ErrorMessage), {
                name: "ethnicity",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'yearsOfExp')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              _cache[106] || (_cache[106] = _createElementVNode("label", { for: "yearsOfExp" }, [
                _createTextVNode("Years of Experience"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).yearsOfExp,
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(values).yearsOfExp) = $event)),
                name: "yearsOfExp",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).yearsOfExp,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(values).yearsOfExp) = $event)),
                    options: yearsOfExpOptionsAdded,
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "yearsOfExp",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'areaOfExpertise')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
              _cache[107] || (_cache[107] = _createElementVNode("label", { for: "areaOfExpertise" }, [
                _createTextVNode("Area of Expertise/Specialization"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).areaOfExpertise,
                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_unref(values).areaOfExpertise) = $event)),
                name: "areaOfExpertise",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).areaOfExpertise,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(values).areaOfExpertise) = $event)),
                    options: areaOfExpertiseOptionsAdded,
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              (_unref(values).areaOfExpertise === 'Others')
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createVNode(_unref(Field), { name: "areaOfExpertise-text" }, {
                      default: _withCtx(({ field }) => [
                        _createElementVNode("input", _mergeProps(field, {
                          placeholder: "Please Specify",
                          class: "form-control bg-others",
                          type: "text",
                          readonly: props.action === 'view'
                        }), null, 16, _hoisted_81)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(ErrorMessage), {
                name: "areaOfExpertise",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'levelEducation')
              ?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
              _cache[108] || (_cache[108] = _createElementVNode("label", { for: "levelEducation" }, [
                _createTextVNode("Minimum Level of Education"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).levelEducation,
                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(values).levelEducation) = $event)),
                name: "levelEducation",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).levelEducation,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(values).levelEducation) = $event)),
                    options: [
                { label: 'No preference', value: 'No preference' },
                { label: 'Diploma', value: 'Diploma' },
                { label: 'Associate Degree', value: 'Associate Degree' },
                { label: 'Bachelor’s degree', value: 'Bachelor’s degree' },
                { label: 'Master’s degree', value: 'Master’s degree' },
                { label: 'Doctoral Degree', value: 'Doctoral Degree' },
              ],
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "levelEducation",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'typeFirm')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _cache[109] || (_cache[109] = _createElementVNode("label", { for: "typeFirm" }, [
                _createTextVNode("Type of Firm"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).typeFirm,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_unref(values).typeFirm) = $event)),
                name: "typeFirm",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).typeFirm,
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(values).typeFirm) = $event)),
                    options: typeOfFirmOptionsAdded,
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              (_unref(values).typeFirm === 'Others')
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _createVNode(_unref(Field), { name: "typeFirm_text" }, {
                      default: _withCtx(({ field, meta }) => [
                        _createElementVNode("input", _mergeProps(field, {
                          class: [{
                  'field-bg-color': !meta.dirty,
                  'field-border-error': meta.dirty && !meta.valid,
                }, "form-control bg-others"],
                          placeholder: "Please Specify",
                          type: "text",
                          readonly: props.action === 'view'
                        }), null, 16, _hoisted_85)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(ErrorMessage), {
                name: "typeFirm",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        (
            !_unref(courseRequestFields).find((el) => el.name === 'sizeFirm')?.disabled
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
              _cache[110] || (_cache[110] = _createElementVNode("label", { for: "sizeFirm" }, [
                _createTextVNode("Size of Firm"),
                _createElementVNode("span", { class: "super font-color-red" }, "*")
              ], -1)),
              _createVNode(_unref(Field), {
                modelValue: _unref(values).sizeFirm,
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_unref(values).sizeFirm) = $event)),
                name: "sizeFirm",
                type: "text",
                class: _normalizeClass(["dropdown", { 'non-editable-select': props.action === 'view' }])
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(Multiselect), _mergeProps(field, {
                    modelValue: _unref(values).sizeFirm,
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref(values).sizeFirm) = $event)),
                    options: sizeOfFirmOptionsAdded,
                    mode: "single",
                    searchable: true,
                    disabled: props.action === 'view',
                    class: { 'field-bg-color': !_unref(meta).dirty && !_unref(meta).valid }
                  }), null, 16, ["modelValue", "disabled", "class"])
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createVNode(_unref(ErrorMessage), {
                name: "sizeFirm",
                class: "error-feedback"
              })
            ]))
          : _createCommentVNode("", true),
        _cache[132] || (_cache[132] = _createElementVNode("br", null, null, -1)),
        (props.action !== 'view')
          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: saveTempCourseRequest,
                  class: "btn btn-secondary btn-block"
                }, _cache[111] || (_cache[111] = [
                  _createElementVNode("span", null, "Save & Continue Later", -1)
                ])),
                _cache[112] || (_cache[112] = _createElementVNode("div", null, null, -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-block",
                  onClick: showPopup
                }, [
                  (_ctx.action === 'update')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Update Course Request"))
                    : _createCommentVNode("", true),
                  (_ctx.action === 'create' || _ctx.action === 'resubmit')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Request Course-Support"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(PopupModal, {
                visible: _unref(isVisible),
                onClose: hidePopup
              }, {
                title: _withCtx(() => _cache[113] || (_cache[113] = [
                  _createTextVNode(" Contact Preference")
                ])),
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_91, [
                    _cache[114] || (_cache[114] = _createElementVNode("label", { for: "contactPref" }, "Please select how you would like to be contacted?", -1)),
                    _createVNode(_unref(Field), {
                      name: "Email",
                      value: "True",
                      type: "checkbox",
                      disabled: ""
                    }),
                    _cache[115] || (_cache[115] = _createTextVNode("Email ")),
                    _cache[116] || (_cache[116] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_unref(Field), {
                      value: "True",
                      "unchecked-value": "False",
                      name: "phone",
                      type: "checkbox"
                    }),
                    _cache[117] || (_cache[117] = _createTextVNode(" Phone ")),
                    _cache[118] || (_cache[118] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_unref(ErrorMessage), {
                      name: "contactPref",
                      class: "error-feedback"
                    })
                  ]),
                  (_unref(values).phone === 'True')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                        _cache[119] || (_cache[119] = _createElementVNode("label", { for: "phoneNumber" }, "Phone Number", -1)),
                        _createVNode(_unref(Field), {
                          name: "phoneNumber",
                          type: "text",
                          class: "form-control"
                        }),
                        _createVNode(_unref(ErrorMessage), {
                          name: "phoneNumber",
                          class: "error-feedback"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _cache[121] || (_cache[121] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-block",
                      onClick: _cache[52] || (_cache[52] = ($event: any) => (
                    (_isRef(isVisible) //@ts-ignore
 ? isVisible.value = false : isVisible = false), (_isRef(isRecommendationsVisible) //@ts-ignore
 ? isRecommendationsVisible.value = true : isRecommendationsVisible = true)
                  ))
                    }, _cache[120] || (_cache[120] = [
                      _createElementVNode("span", null, "Proceed", -1)
                    ]))
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(PopupModal, {
                visible: _unref(isRecommendationsVisible),
                onClose: _cache[54] || (_cache[54] = ($event: any) => (_isRef(isRecommendationsVisible) //@ts-ignore
 ? isRecommendationsVisible.value = false : isRecommendationsVisible = false))
              }, {
                title: _withCtx(() => _cache[122] || (_cache[122] = [])),
                content: _withCtx(() => [
                  _cache[126] || (_cache[126] = _createElementVNode("div", null, " To complete the submission of your request, kindly make a maximum of three (3) selections from the recommended practitioners on the next page. Your request would be sent to practitioner(s) that you select. ", -1)),
                  _cache[127] || (_cache[127] = _createElementVNode("br", null, null, -1)),
                  _cache[128] || (_cache[128] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary btn-block",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => (_isRef(isRecommendationsVisible) //@ts-ignore
 ? isRecommendationsVisible.value = false : isRecommendationsVisible = false)),
                      disabled: _unref(loading)
                    }, _cache[123] || (_cache[123] = [
                      _createElementVNode("span", null, "Back", -1)
                    ]), 8, _hoisted_95),
                    _cache[125] || (_cache[125] = _createElementVNode("div", null, null, -1)),
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-block",
                      disabled: _unref(loading)
                    }, [
                      _withDirectives(_createElementVNode("span", _hoisted_97, null, 512), [
                        [_vShow, _unref(loading)]
                      ]),
                      _cache[124] || (_cache[124] = _createElementVNode("span", null, "Accept", -1))
                    ], 8, _hoisted_96)
                  ])
                ]),
                _: 1
              }, 8, ["visible"])
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    (_unref(message))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_unref(successful) ? 'alert-success' : 'alert-danger')
        }, _toDisplayString(_unref(message)), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})